import {useNavigate} from 'react-router-dom';
import {useToggle} from '@mantine/hooks';
import {I18n} from '@aws-amplify/core';


import {
    AiOutlineEdit,
    AiOutlineProfile
} from 'react-icons/ai';
import {
    FlexiButton,
    FlexiCancelButton
} from "@flexinet/ui-components";
import {useVerifiedPermissions} from '@flexinet/auth-components';
import {rbacActions} from "../../../config/rbac/actions.ts";

// Close returns to the product the line item belongs to, whose Line Items tab is this
// module's list.
export const useEditPageTools = (productId: string) => {

    const navigate = useNavigate();

    const {allowedActions} = useVerifiedPermissions()

    const [mode, toggle] = useToggle(['view', 'edit']);

    const tools = [];


    if (allowedActions.includes(rbacActions.UpdateProductLineItem)) {

        if (mode === 'edit') {
            tools.push(<FlexiButton variant={'filled'} key={'profile'}
                                    leftSection={<AiOutlineProfile/>}
                                    onClick={() => toggle()}>{I18n.get('Profile')}</FlexiButton>);
        } else {
            tools.push(<FlexiButton leftSection={<AiOutlineEdit/>} variant={'filled'} key={'edit'}
                                    onClick={() => toggle()}>{I18n.get('Edit')}</FlexiButton>);
        }

    }

    tools.push(<FlexiCancelButton key={'close'}
                                  onClick={() => navigate(`/products/${productId}`)}/>);


    return {
        mode,
        tools,
    };

};
